import axiosInstance from "./api_helper";

const supplierService = {
    get: async (id) => (await axiosInstance.get(`/api/fournisseurs/${id}`)).data.body,
    articles: async (id) => (await axiosInstance.get(`/api/fournisseurs/${id}/articles`)).data.body,
    saveArticle: async (id, article) => (await axiosInstance.put(
        `/api/fournisseurs/${id}/articles/${article.articleId}`, article
    )).data.body,
    search: async ({ query = '', page = 0, size = 4000 }) => {
        return axiosInstance.get('/api/fournisseurs/search', {
            params: { query, page, size }
        });
    },
    findAll: async ({ query = '', page = 0, size = 4000 }) => {
        return axiosInstance.get('/api/fournisseurs/search/all', {
            params: { query, page, size }
        });
    },

    delete: async (id) => {
        return axiosInstance.delete(`/api/fournisseurs/${id}`);
    },
    save: async (payload) => {
        return axiosInstance.post(`/api/fournisseurs`, JSON.stringify(payload));
    },
    importSuppliers: async (file) => {
        const formData = new FormData();
        formData.append('file', file);

        return axiosInstance.post('/api/fournisseurs/importer', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },
    update: async (payload) => {
        console.log(payload)
        return axiosInstance.put(`/api/fournisseurs/${payload.id}`, JSON.stringify(payload.data));
    },
    findArticlePrice: async ({fournisseurId, productId}) => {
        return axiosInstance.post(`/api/fournisseurs/article-price`, JSON.stringify({ fournisseurId, productId }));
    },
    inactivate: async (id) => {
        return axiosInstance.delete(`/api/fournisseurs/${id}`);
    },

    activate: async (id) => {
        return axiosInstance.put(`/api/fournisseurs/activer/${id}`);
    },

};
export default supplierService;
